import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Scroll animations — no CSS filter:blur (causes repaint on every frame).
 * Uses only transform + opacity for GPU-composited animations.
 */
export default function ScrollAnimator() {
  useEffect(() => {
    // Hero parallax
    const heroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '#hero',
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5,
      },
    });
    heroTl.to('#hero-content', { y: -120, opacity: 0, scale: 0.97, ease: 'none' });
    heroTl.to('#hero-canvas', { y: -60, ease: 'none' }, 0);

    // Shared reveal config — opacity + y only, no blur
    const reveal = (trigger: string, targets: string | string[], stagger = false) => {
      const tgts = Array.isArray(targets) ? targets : [targets];
      tgts.forEach((sel) => {
        gsap.fromTo(
          sel,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: stagger ? 0.12 : 0,
            ease: 'power3.out',
            scrollTrigger: {
              trigger,
              start: 'top 75%',
              toggleActions: 'play none none reverse',
            },
          },
        );
      });
    };

    // Section reveals
    reveal('#how-it-works', '.step-card', true);
    reveal('#security', ['.security-text']);
    reveal('#security', '.security-point', true);
    reveal('#for-agencies', '#for-agencies .feature-item', true);
    reveal('#for-workers', '#for-workers .feature-item', true);
    reveal('#pricing', '.pricing-card');
    reveal('#cta', '#cta .cta-content');

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return null;
}
